import { z } from 'zod';

export const PromoCodeDiscountTypeSchema = z.enum(['fixed', 'percent']);
export type PromoCodeDiscountType = z.infer<typeof PromoCodeDiscountTypeSchema>;

export const AdminPromoCodeClubSchema = z.object({
  id: z.string(),
  title: z.string(),
});
export type AdminPromoCodeClub = z.infer<typeof AdminPromoCodeClubSchema>;

export const AdminPromoCodeResponseSchema = z.object({
  id: z.string(),
  code: z.string(),
  discountType: PromoCodeDiscountTypeSchema,
  discountValue: z.number().int(),
  expiresAt: z.string().datetime(),
  activationLimit: z.number().int().nullable(),
  usageCount: z.number().int(),
  isActive: z.boolean(),
  clubScope: z.enum(['all', 'selected']),
  clubs: z.array(AdminPromoCodeClubSchema),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type AdminPromoCodeResponse = z.infer<typeof AdminPromoCodeResponseSchema>;

const ClubIdsSchema = z.array(z.string().uuid()).default([]);

const PromoCodeMutationShape = {
  code: z.string().trim().min(1).max(40).refine((value) => !/\s/.test(value), {
    message: 'Code must not contain whitespace',
  }),
  discountType: PromoCodeDiscountTypeSchema,
  discountValue: z.number().int().positive(),
  expiresAt: z.string().datetime(),
  activationLimit: z.number().int().positive().nullable().optional(),
  isActive: z.boolean().optional(),
  clubIds: ClubIdsSchema,
};

export const AdminCreatePromoCodeSchema = z.object(PromoCodeMutationShape).refine((value) => value.discountType !== 'percent' || value.discountValue <= 100, {
    message: 'Percent discount must be at most 100',
    path: ['discountValue'],
  });
export type AdminCreatePromoCodeDto = z.infer<typeof AdminCreatePromoCodeSchema>;

export const AdminUpdatePromoCodeSchema = z
  .object(PromoCodeMutationShape)
  .partial()
  .refine((value) => Object.keys(value).length > 0, { message: 'At least one field is required' })
  .refine((value) => value.discountType !== 'percent' || value.discountValue === undefined || value.discountValue <= 100, {
    message: 'Percent discount must be at most 100',
    path: ['discountValue'],
  });
export type AdminUpdatePromoCodeDto = z.infer<typeof AdminUpdatePromoCodeSchema>;

export const AdminPromoCodeListResponseSchema = z.object({
  items: z.array(AdminPromoCodeResponseSchema),
});
export type AdminPromoCodeListResponse = z.infer<typeof AdminPromoCodeListResponseSchema>;
